<template>
	<div>
		<button @click="startPurchaseTicketFlow"
				class="better-mobile-btn">
			<i class="fas fa-ticket-alt"></i>
			Purchase Ticket
		</button>

		<EnterUserInformation
			:is-entering-user-information="isEnteringUserInformation"
			@submit="enteredUserInformation"
			@cancel="cancelEnterUserInformation"
		/>

		<SignTermsAndConditions
			:is-signing-terms="isSigningTerms"
			:url="termsAsBase64"
			:error-fetching-terms="hadErrorFetchingTerms"
			@submit="signedTerms"
			@signedPhysical="signedPhysicalTerms"
			@skipped="skippedTerms"
			@cancel="cancelSignTerms"
		/>

		<ErrorPopup
			:show="shouldShowError"
			:error-message="errorMessage"
			:btn-text="errorMessageBtn"
			@close="closeError"
		/>
	</div>
</template>

<script>
import axios from "axios";
import ErrorPopup from "@/components/ErrorPopup.vue";
import EnterUserInformation from "@/components/EnterUserInformation.vue";
import SignTermsAndConditions from "@/components/SignTermsAndConditions.vue";
import cookieService from '@/cookie-utilities.js';

const SIGNED_PHYSICAL = "physical"
const SIGNED_TERMS = "scanner-app"
const SKIPPED_TERMS = "skipped"
const plainAxios = axios.create();

export default {
	components: {
		SignTermsAndConditions,
		EnterUserInformation,
		ErrorPopup,
	},
	data() {
		return {
			isEnteringUserInformation: false,
			isSigningTerms: false,
			shouldShowError: false,
			errorMessage: "Oops!",
			errorMessageBtn: "Proceed",
			firstName: "",
			lastName: "",
			email: "",
			phone: "",
			selectedTicket: "",
			termsUri: "",
			termsVersion: "",
			fullTermsUrl: "",
			termsAsBase64: "",
			hadErrorFetchingTerms: false,
			signedAt: null,
			signature: "",
		}
	},
	methods: {
		startPurchaseTicketFlow() {
			this.isEnteringUserInformation = true
			this.isSigningTerms = false
			this.fetchTerms()
		},
		enteredUserInformation(data) {
			this.firstName = data.firstName
			this.lastName = data.lastName
			this.email = data.email
			this.phone = data.phone
			this.selectedTicket = data.selectedTicket
			this.isEnteringUserInformation = false
			this.isSigningTerms = true
		},
		cancelEnterUserInformation() {
			this.isEnteringUserInformation = false
			this.isSigningTerms = false
		},
		signedTerms(data) {
			this.signature = data.signature
			this.signedAt = data.signedAt

			this.isEnteringUserInformation = false
			this.isSigningTerms = false
			this.addToParty(SIGNED_TERMS)
		},
		signedPhysicalTerms() {
			this.isEnteringUserInformation = false
			this.isSigningTerms = false
			this.addToParty(SIGNED_PHYSICAL)
		},
		skippedTerms() {
			this.isEnteringUserInformation = false
			this.isSigningTerms = false
			this.addToParty(SKIPPED_TERMS)
		},
		cancelSignTerms() {
			this.isSigningTerms = false
			this.isEnteringUserInformation = true
		},
		fetchTerms() {
			const cachedTerms = cookieService.read(cookieService.TERMS_AND_CONDITIONS)
			if(cachedTerms) {
				const terms = JSON.parse(cachedTerms)
				this.termsUri = terms.cookie.termsUri
				this.termsVersion = terms.cookie.termsVersion
				this.fullTermsUrl = terms.cookie.fullTermsUrl
				this.fetchPdfAsBase64()
			} else {
				const scannerRegKey = localStorage.getItem('scanner_regkey');
				axios.post(`${this.$scanner.api_server}/api/scannerdevice/terms`, {
					check: scannerRegKey,
				})
					.then(res => {
						this.termsUri = res.data.data.uri
						this.termsVersion = res.data.data.terms_version
						this.fullTermsUrl = `${this.$scanner.api_server}` + this.termsUri + '?v=' +Date.now()
						this.fetchPdfAsBase64()
						this.hadErrorFetchingTerms = false

						const cookie = {
							termsUri: this.termsUri,
							termsVersion: this.termsVersion,
							fullTermsUrl: this.fullTermsUrl,
						}
						cookieService.write(cookieService.TERMS_AND_CONDITIONS, JSON.stringify({cookie}), 60)
					})
					.catch(err => {
						this.hadErrorFetchingTerms = true
						this.showError(err.response && err.response.data.message ? err.response.data.message : "Error fetching the terms & conditions", "Proceed")
					})
			}
		},
		fetchPdfAsBase64() {
			const scannerRegKey = localStorage.getItem('scanner_regkey');
			return axios.post(`${this.$scanner.api_server}/api/scannerdevice/terms_as_base64`, {
				check: scannerRegKey,
			})
				.then(response => {
					this.termsAsBase64 = response.data.data.base64
				})
				.catch(err => {
					this.hadErrorFetchingTerms = true
					this.showError(err.response && err.response.data.message ? err.response.data.message : "Error fetching the terms & conditions", "Proceed")
				})
		},
		addToParty(signedVia) {
			window.scanner.loader.open()

			const scannerRegKey = localStorage.getItem('scanner_regkey');
			axios.defaults.headers.common['X-Auth-Token'] = scannerRegKey;

			let payload = {
				check: scannerRegKey,
				first_name: this.firstName,
				last_name: this.lastName,
				email: this.email,
				phone: this.phone,
				ticket_ect_id: this.selectedTicket,
				signed_via: signedVia,
			}

			if(signedVia === SIGNED_TERMS) {
				payload = {
					...payload,
					terms_version: this.termsVersion,
					signature: this.signature,
					signed_at: this.signedAt,
				}
			}

			axios.post(`${this.$scanner.api_server}/api/scannerdevice/party/${this.$scanner.partyId}/addNewTicketUser`, payload)
				.then(res => {
					if (res.status === 200) {
						window.scanner.loader.close()
						this.$emit('submit')
					}
				})
				.catch(err => {
					this.showError(err.response && err.response.data.message ? err.response.data.message : "Error adding the user", "Try Again")
					window.scanner.loader.close()
				})
		},
		showError(msg = 'Big time Error, contact champion support', btnText = 'Ok') {
			this.shouldShowError = true
			this.errorMessage = msg
			this.errorMessageBtn = btnText
		},
		closeError() {
			this.shouldShowError = false
		},
	},
}
</script>

<style scoped>
</style>